import { render } from "./ClipboardIcon.vue?vue&type=template&id=5c16247a"
import script from "./ClipboardIcon.vue?vue&type=script&lang=js"
export * from "./ClipboardIcon.vue?vue&type=script&lang=js"
script.render = render

export default script